import * as React from 'react';
import { IOption, IOptionGroup } from "../../classes/seating-option";
import { formatId } from '../../helpers/string-format';

interface IRadioProps{
    key: string;
    onChangeFunction: (IOption, IOptionGroup) => any;
    checked: boolean;

    option: IOption;
    optionGroup: IOptionGroup;
    disabled: boolean;
}

class Radio extends React.Component<IRadioProps, any> {
    render() {
        const validId = `r_${formatId(this.props.option.id)}`;
        return (
            <li className="form-item">
                <input type="radio" disabled={this.props.disabled} name={this.props.optionGroup.name} value={this.props.option.id} id={validId}
                    onClick={() => { this.props.onChangeFunction(this.props.option, this.props.optionGroup) } }
                    checked={this.props.checked}/>
                <label htmlFor={validId} dangerouslySetInnerHTML={{ __html: this.props.option.name }}></label>
            </li>
        );
    }
}

export default Radio;